import { initAdTraction } from "./adTraction";
import { initBlueConic } from "./blueconic";
import { initCoreWebVitals } from "./core-web-vitals";
import { initCustomPageViewSingleSPA } from "./custom-page-view";
import { initGiosg } from "./giosg";
import { initGTM } from "./gtm";
import { initInzynk } from "./inzynk";
import { initMedallia } from "./medallia";
import { initOneTrust } from "./onetrust";
import { initOptimizely } from "./optimizely";
import { initPageviewQueue } from "./pageview-queue";
import { initPardot } from "./pardot";

// Next.js apps
export const init = () => {
  initPageviewQueue();
  initOneTrust();
  initGTM();
  initBlueConic();
  initCoreWebVitals();
  initGiosg();
  initMedallia();
  initOptimizely();
  initAdTraction();
  initPardot();
  initInzynk();
};

// MyBusiness
export const initMyBusinessSingleSPA = () => {
  initOneTrust();
  initCustomPageViewSingleSPA();
  initCoreWebVitals();
  initGTM();
  initMedallia();
  // initBlueConic();
};
